import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DeleteFlashMessageRequest } from './deleteflashmessagesrequest';

export class DeleteFlashMessageAPI extends SixdeeCRBTAPI<DeleteFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/delete-instant-flash-settings";
    }

    protected getRequestData() {
        return {
             "msisdn":this.getRequest().getMsisdn()
         };
     }

     getBASEURL(): string
     {
         return this.getContext().getProperty().getFlashURL() + 
             this.getAPIURL();
     }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/delete/deleteflashmessagesapi.tsx